export class UserStatus {
  constructor(public isAuthenticated: boolean,
              public securityGroup: number = 1000) {}
}
